import { memo } from 'react';
import css from './Box.module.scss';
import classNames from 'classnames';
import { BoxProps } from './Box.types';

/**
 * A styling component that wraps child components to display a color based on the OEM theme.
 *
 * @param color - {@link BoxProps.color color} description.
 * @param children - {@link BoxProps.children children} description.
 */
const Box = memo(({
    color,
    children,
}: BoxProps) => {
    return (
        <div role={'presentation'} className={classNames(css.box, css[color])}>
            {children}
        </div>
    );
});

export default Box;
